<template>
  <dialog class="modal backdrop-color position-settings" id="my_information" >
    <div class="modal-box important-information md:!max-w-[755px] !max-h-full !w-full !max-w-full !rounded-xl !p-0">
      <form class="flex justify-center border-b px-7 text-dark-blue-2 sticky top-0 w-full bg-white left-0 z-50 py-[18px]"
            method="dialog">
        <button class="absolute rounded-full left-[29px] focus:outline-none focus:border-0 focus:ring-0"><i class="fa-solid fa-xmark text-xl"></i></button>
        <p class="leading-6 font-bold text-center text-[17px]">{{ $t('layout.search.modal.info.important_info') }}</p>
      </form>
      <div class="py-10 px-6 max-md:pb-20 text-left">
        <h3 class="font-bold leading-7 mb-6 text-xl text-dark-blue-2 text-left">{{ $t('layout.search.modal.info.know_about_your_booking') }}</h3>
        <div class="relative block md:flex pb-6 mb-7 border-b border-menu-b gap-6">
          <div class="relative flex gap-3 items-start md:w-[195px] text-left">
            <img src="/assets/customer-v3/img/modal/info/driver-requirements.svg" alt="driver-requirements">
            <p class="leading-6 font-bold text-dark-blue-2 text-[17px] md:w-[152px] text-left"> {{ $t('layout.search.modal.info.driver_requirements') }}</p>
          </div>
          <div class="relative mt-5 md:mt-0 w-full lg:w-[calc(100%_-_195px)]">
            <p class="text-base leading-6 text-light-blue-2 mb-2">{{ $t('layout.search.modal.info.things_to_bring') }}</p>
            <div class="car-feature-list-area relative text-left">
              <div class="text-light-blue-2 text-base leading-6 mb-1 pl-8 relative last:mb-0">{{ $t('layout.search.modal.info.driver_license') }}</div>
              <div class="text-light-blue-2 text-base leading-6 mb-1 pl-8 relative last:mb-0">{{ $t('layout.search.modal.info.driver_id') }}</div>
              <div class="text-light-blue-2 text-base leading-6 mb-1 pl-8 relative last:mb-0">{{ $t('layout.search.modal.info.customer_verification') }}</div>
            </div>
          </div>
        </div>
        <div class="relative block md:flex pb-6 mb-7 border-b border-menu-b gap-6">
          <div class="relative flex gap-3 items-start md:w-[195px] text-left">
            <img src="/assets/customer-v3/img/modal/info/pickup.svg" alt="Pickup">
            <p class="leading-6 font-bold text-dark-blue-2 text-[17px] md:w-[152px] text-left"> {{ $t('layout.search.modal.info.timings') }}</p>
          </div>
          <div class="relative mt-5 md:mt-0 w-full lg:w-[calc(100%_-_195px)]">
            <p class="text-base leading-6 text-light-blue-2 mb-1">{{ $t('layout.search.modal.info.timings_desc') }}</p>
            <div class="bullet-points text-left mb-7 relative">
              <div class="text-light-blue-2 text-base leading-6 mb-1 pl-5 relative last:mb-0">
                <span class="font-bold">{{ $t('layout.search.modal.info.pickup') }}: </span>
                <template v-if="allowLocationWorkHoursBreaks && getCarInfo(car.id).pickup_break_start && getCarInfo(car.id).pickup_break_end && !getCarInfo(car.id).default_pickup_time">
                  {{ $t('layout.search.modal.info.pickup_time') + ' ' + getCarInfo(car.id).pickup_time_min + ' - ' + (getCarInfo(car.id).pickup_break_start) + ', ' + (getCarInfo(car.id).pickup_break_end) + ' - ' + getCarInfo(car.id).pickup_time_max }}
                </template>
                <template v-else>
                  {{ $t('layout.search.modal.info.pickup_time') + ' ' + (getCarInfo(car.id).default_pickup_time ? getCarInfo(car.id).default_pickup_time : (getCarInfo(car.id).pickup_time_min + ' - ' + getCarInfo(car.id).pickup_time_max))}}
                </template>
              </div>
              <div class="text-light-blue-2 text-base leading-6 mb-1 pl-5 relative last:mb-0"><span class="font-bold">{{ $t('layout.search.modal.info.return') }}: </span>
                {{ $t('layout.search.modal.info.delivery_latest_at', {time: getCarInfo(car.id).default_delivery_time ? getCarInfo(car.id).default_delivery_time : getCarInfo(car.id).delivery_time_min})}}
              </div>
              <div v-if="getClosestDepartment(car).key_box" class="text-light-blue-2 text-base leading-6 mb-1 pl-5 relative last:mb-0"><span class="font-bold">{{ $t('layout.search.modal.info.keybox_delivery') }}: </span>
                {{ $t('layout.search.modal.info.keybox_delivery_24h') }}
              </div>
            </div>
            <p class="text-base leading-6 text-light-blue-2 mb-2">
              <span class="font-bold">Oscar {{ getClosestDepartment(car).name[appLocale] }} </span>
              {{ $t('layout.search.modal.info.location_timings') }}:
            </p>
            <div class="bullet-points text-left relative" v-if="getCollectiveDaysTime !== false">
              <div class="text-light-blue-2 text-base leading-6 mb-1 pl-5 relative last:mb-0">{{ $t(`layout.labels.subscription.monday_to_friday`) }} {{ getCollectiveDaysTime }}</div>
              <div v-for="day in weekdayName.filter(dayObj => dayObj.index === 6 || dayObj.index === 0 || dayObj.index === 'holiday')" class="text-light-blue-2 text-base leading-6 mb-1 pl-5 relative last:mb-0">{{ $t(`layout.days.${day.day}`) }}: {{ getOpeningTime(day.index) }}</div>
            </div>
            <div class="bullet-points text-left relative" v-else>
              <div v-for="day in weekdayName" class="text-light-blue-2 text-base leading-6 mb-1 pl-5 relative last:mb-0">{{ $t(`layout.days.${day.day}`) }}: {{ getOpeningTime(day.index) }}</div>
            </div>
          </div>
        </div>
        <!--TODO-->
        <div class="relative block md:flex pb-6 mb-7 border-b border-menu-b gap-6">
          <div class="relative flex gap-3 items-start md:w-[195px] text-left">
            <img src="/assets/customer-v3/img/modal/info/deposit-card.svg" alt="Security deposit">
            <div class="md:w-[152px] w-full flex align-center justify-between md:block">
              <p class="leading-6 font-bold text-dark-blue-2 text-[17px] md:w-[152px] text-left"> {{ $t('layout.search.modal.info.security_deposit')}}</p>
              <p class="leading-6 font-normal text-dark-blue-2 mt-1 text-[17px] text-left">{{ getDepositRange() }}</p>
            </div>
          </div>
          <div class="relative mt-5 md:mt-0 w-full lg:w-[calc(100%_-_195px)]">
            <p class="text-base leading-6 text-light-blue-2 mb-2" v-html="$t('layout.search.modal.info.security_deposit_desc', {maxDeposit: formatPrice(getMaxDeposit()), basic: formatPrice(getDepositValue('basic')), standard: formatPrice(getDepositValue('standard')), premium: formatPrice(getDepositValue('premium'))})">
            </p>
            <p class="mt-8 font-bold text-light-blue-2 mb-2">{{ $t('layout.search.modal.info.accepted_payment_methods')}}:</p>
            <div class="text-left flex gap-2">
              <img height="56" width="42" v-for="paymentMethod in paymentMethods" :src="`/assets/shared/img/payment_methods/${paymentMethod.startsWith('payment-invoice') ? 'payment-invoice' + countryIso : paymentMethod}`"  :alt="paymentMethod"/>
            </div>
          </div>
        </div>
        <!--TODO-->
        <div class="relative block md:flex pb-6 mb-7 border-b border-menu-b gap-6">
          <div class="relative flex gap-3 items-start md:w-[195px] text-left">
            <img src="/assets/customer-v3/img/modal/info/damage-icon.svg" alt="damage-icon">
            <div class="md:w-[152px] w-full flex align-center justify-between md:block">
              <p class="leading-6 font-bold text-dark-blue-2 text-[17px] md:w-[152px] text-left"> {{ $t('layout.search.modal.info.damage_access')}}</p>
              <p class="leading-6 font-normal text-dark-blue-2 mt-1 text-[17px] text-left">{{ getExcessRange() }}</p>
            </div>
          </div>
          <div class="relative mt-5 md:mt-0 w-full lg:w-[calc(100%_-_195px)]">
            <p class="text-base leading-6 text-light-blue-2 mb-2" v-html="$t('layout.search.modal.info.damage_access_desc', {maxExcess: formatPrice(getMaxExcess()), basic: formatPrice(getExcessValue('basic')), standard: formatPrice(getExcessValue('standard')), premium: formatPrice(getExcessValue('premium'))})"></p>
          </div>
        </div>
        <div class="relative block md:flex pb-6 mb-7 border-b border-menu-b gap-6">
          <div class="relative flex gap-3 items-start md:w-[195px] text-left">
            <img src="/assets/customer-v3/img/modal/info/fuel-icon.svg" alt="Fuel policy">
            <div class="md:w-[152px] w-full flex align-center justify-between md:block">
              <p class="leading-6 font-bold text-dark-blue-2 text-[17px] md:w-[152px] text-left"> {{ $t('layout.search.modal.info.fuel_policy')}}</p>
              <p class="leading-6 font-normal text-dark-blue-2 mt-1 text-[17px] text-left"> {{ $t('layout.search.modal.info.like_like') }}</p>
            </div>
          </div>
          <div class="relative mt-5 md:mt-0 w-full lg:w-[calc(100%_-_195px)]">
            <p class="text-base leading-6 text-light-blue-2 mb-2">
              {{ $t('layout.search.modal.info.fuel_policy_desc')}}
            </p>
          </div>
        </div>
        <div class="relative block md:flex pb-6 mb-7 border-b border-menu-b gap-6">
          <div class="relative flex gap-3 items-start md:w-[195px] text-left">
            <img src="/assets/customer-v3/img/modal/info/policy-icon.svg" alt="Cancellation policy">
            <p class="leading-6 font-bold text-dark-blue-2 text-[17px] md:w-[152px] text-left"> {{ $t('layout.search.modal.info.cancellation_policy')}}</p>
          </div>
          <div class="relative mt-5 md:mt-0 w-full lg:w-[calc(100%_-_195px)]">
            <p class="text-base leading-6 text-light-blue-2 mb-2">{{ $t('layout.search.modal.info.cancellation_policy_desc')}}</p>
          </div>
        </div>
        <div class="relative block md:flex pb-6 mb-7 border-b border-menu-b gap-6">
          <div class="relative flex gap-3 items-start md:w-[195px] text-left">
            <img src="/assets/customer-v3/img/modal/info/mileage.svg" alt="Mileage">
            <div class="md:w-[152px] w-full flex align-center justify-between md:block">
              <p class="leading-6 font-bold text-dark-blue-2 text-[17px] md:w-[152px] text-left"> {{ $t('layout.search.modal.info.mileage')}}</p>
              <p class="leading-6 font-normal text-dark-blue-2 mt-1 text-[17px] text-left"> {{ $t('layout.search.modal.info.mileage_included',{distanceUnitShort: distanceUnitShort, 'km': getCarInfo(car.id).is_long_booking ? (+car.long_term_km_included * daysCount) : (+car.km_included * daysCount) })}}</p>
            </div>
          </div>
          <div class="relative mt-5 md:mt-0 w-full lg:w-[calc(100%_-_195px)]">
            <p class="text-base leading-6 text-light-blue-2 mb-1" v-html="$t('layout.search.modal.info.drive_more_pay_more', {distanceUnitShort: distanceUnitShort, distanceUnitLong: distanceUnitLong, includedKm: getCarInfo(car.id).is_long_booking ? (+car.long_term_km_included * daysCount) : (+car.km_included * daysCount), pricePerKm: getCarInfo(car.id).is_long_booking ? formatPrice(car.long_term_km_price) : formatPrice(car.km_price)})"></p>
            <div class="bullet-points text-left mb-7 relative" v-if="1===0">
              <div class="text-light-blue-2 text-base leading-6 mb-1 pl-5 relative last:mb-0">100 km -&gt; 10% discount
              </div>
              <div class="text-light-blue-2 text-base leading-6 mb-1 pl-5 relative last:mb-0">200 km -&gt; 20% discount
              </div>
              <div class="text-light-blue-2 text-base leading-6 mb-1 pl-5 relative last:mb-0">300 km -&gt; 30% discount
              </div>
              <div class="text-light-blue-2 text-base leading-6 mb-1 pl-5 relative last:mb-0">400 km -&gt; 40% discount
              </div>
            </div>
            <p v-if="countryIso !== 'us'" class="text-base leading-6 text-light-blue-2 mb-2 italic">{{ $t('layout.search.modal.info.discount_application')}}</p>
          </div>
        </div>
      </div>
      <div class="sticky bottom-0 w-full h-20 bg-white">
        <div class="relative flex border-t border-menu-b py-3 justify-between gap-5 px-6 items-center">
          <form class="flex justify-center" method="dialog">
            <button class="text-dark-blue-2 text-base leading-5 border-b border-dark-blue-2 h-5">{{ $t('layout.search.modal.info.button.close') }}</button>
          </form>
          <form class="flex justify-center" method="dialog">
            <button class="button-orange !bg-dark-blue-2 !border-dark-blue-2 hover:!text-white px-16">{{ $t('layout.search.modal.info.button.understood') }}</button>
          </form>
        </div>
      </div>
    </div>
    <form class="modal-backdrop" method="dialog">
      <button>close</button>
    </form>
  </dialog>
</template>

<script>
  import { formatPrice } from '../../../shared/js/numberUtils';
  import { dayjs } from '../../../shared/js/dateUtils'

  export default {
    name: "InformationModal",
    props: {
      car: {
        type: Object,
        required: true,
      },
      getClosestDepartment: {
        type: Function,
        required: true,
      },
      getCarInfo: {
        type: Function,
        required: true,
      },
      appLocale: {
        type: String,
        required: true
      },
      daysCount: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        paymentMethods: window.paymentMethods,
        distanceUnitShort: window.distanceUnit,
        distanceUnitLong: window.distanceUnitLong,
        countryIso: window.countryIso,
        weekdayName: [
          {'day': 'Monday', 'index': 1},
          {'day': 'Tuesday', 'index': 2},
          {'day': 'Wednesday', 'index': 3},
          {'day': 'Thursday', 'index': 4},
          {'day': 'Friday', 'index': 5},
          {'day': 'Saturday', 'index': 6},
          {'day': 'Sunday', 'index': 0},
          {'day': 'Holiday', 'index': 'holiday'}
        ],
        allowLocationWorkHoursBreaks: window.allowLocationWorkHoursBreaks,
      };
    },
    methods: {
      getOpeningTime(index) {
        const openingTiming = this.getClosestDepartment(this.car).opening_timing;

        if (openingTiming.length > 0) {
          const day = openingTiming.find(timing => timing.day === index.toString());

          if (day) {
            if (day.is_closed === true) {
              return this.$t('layout.labels.subscription.pickup_location.closed');
            }
            let hours = ''
            if (day.open) {
              hours = this.formatTime(day.open) + ' - ';
            }

            if (this.allowLocationWorkHoursBreaks && day.break_start && day.break_end) {
              hours += `${this.formatTime(day.break_start)}, ${this.formatTime(day.break_end)} - `
            }

            if (day.close) {
              hours += this.formatTime(day.close);
            }

            return hours;
          }
        }
        return this.$t('layout.labels.subscription.pickup_location.closed');
      },
      formatTime(time) {
        return dayjs(time, 'HH:mm:ss').format(window.jsTimeFormat)
      },
      getDepositRange() {
        const excessPackages = this.getClosestDepartment(this.car).excess_packages || {};
        const min = Math.min(
          excessPackages?.basic?.deposit[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
          excessPackages?.standard?.deposit[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
          excessPackages?.premium?.deposit[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
        );
        const max = Math.max(
          excessPackages?.basic?.deposit[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
          excessPackages?.standard?.deposit[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
          excessPackages?.premium?.deposit[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
        );

        return min === max ? formatPrice(min) : `${formatPrice(min)} - ${formatPrice(max)}`;
      },
      getDepositValue(type) {
        const excessPackages = this.getClosestDepartment(this.car).excess_packages || {};
        return excessPackages[type]?.deposit[this.getCarInfo(this.car.id).price_type || 'price'] || 0;
      },
      getMaxDeposit() {
        const excessPackages = this.getClosestDepartment(this.car).excess_packages || {};

        return Math.max(
          excessPackages?.basic?.deposit[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
          excessPackages?.standard?.deposit[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
          excessPackages?.premium?.deposit[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
        );
      },
      getExcessRange() {
        const excessPackages = this.getClosestDepartment(this.car).excess_packages || {};
        const min = Math.min(
          excessPackages?.basic?.excess[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
          excessPackages?.standard?.excess[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
          excessPackages?.premium?.excess[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
        );
        const max = Math.max(
          excessPackages?.basic?.excess[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
          excessPackages?.standard?.excess[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
          excessPackages?.premium?.excess[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
        );

        return min === max ? formatPrice(min) : `${formatPrice(min)} - ${formatPrice(max)}`;
      },
      getExcessValue(type) {
        const excessPackages = this.getClosestDepartment(this.car).excess_packages || {};
        return excessPackages[type]?.excess[this.getCarInfo(this.car.id).price_type || 'price'] || 0;
      },
      getMaxExcess() {
        const excessPackages = this.getClosestDepartment(this.car).excess_packages || {};

        return Math.max(
          excessPackages?.basic?.excess[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
          excessPackages?.standard?.excess[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
          excessPackages?.premium?.excess[this.getCarInfo(this.car.id).price_type || 'price'] || 0,
        );
      },
    },
    computed: {
      getCollectiveDaysTime() {
        let arrayIndex = 0;
        const weekDays = this.weekdayName.filter(day => day.index !== 0 && day.index !== 6 && day.index !== 'holiday');
        for(const dayObject of weekDays) {
          if (arrayIndex === 0) {
            arrayIndex++;
            continue;
          }
          if (this.getOpeningTime(dayObject.index) != this.getOpeningTime(this.weekdayName[arrayIndex - 1].index)) {
            return false;
          }
          arrayIndex++;
        }
        return this.getOpeningTime(weekDays[0].index);
      },
    },
  }
</script>
